<template>
  <div id="ReportTicketSalesTable">
    <StyledTableReport
      :headers="headersReport"
      :details="detailsReport"
      :title="titleReport"
      :includeTotalSales="false"
      :totals="{ tickets: soldTickets, canje: exchangedTickets, totalTickets: totalTickets, total: 0 }"
      :totalColspan="1"
      center
    >
      <tr
        v-for="(item, index1) in ticketsDetails"
        :key="`ticketsDetails-report-${index1}`"
      >
        <td align="center">
          {{ item.Fecha }}
        </td>
        <td align="center">
          {{ $formatNum(item.Cantidad) }}
        </td>
        <td align="center">
          {{ $formatNum(item.Canje) }}
        </td>
        <td align="center">
          {{ $formatNum(item.Boleto) }}
        </td>
      </tr>
    </StyledTableReport>
  </div>
</template>

<script>
import StyledTableReport from '../tools/reports/StyledTableReport.vue'
export default {
  name: 'ReportTicketSalesTable',
  components: { StyledTableReport },
  props: [
    'dateStart',
    'dateEnd',
    'titleReport',
    'ticketsDetails',
    'soldTickets',
    'exchangedTickets',
    'totalTickets'
  ],
  data () {
    return {
      headersReport: [
        { name: 'Fecha', attrs: { } },
        { name: 'Vendidos', attrs: { } },
        { name: 'Canjes', attrs: { } },
        { name: 'total', attrs: { } }
      ],
      detailsReport: [
        {
          key: 'Fecha',
          value: `${this.$formatFecha(this.dateStart)} al ${this.$formatFecha(this.dateEnd)}`,
          attrs: { class: 'pt-2' }
        }
      ]
    }
  }

}
</script>

<style>

</style>
